import React, { Fragment, useEffect, useState } from 'react';
import GridCellWrapper from '../../../components/grid-cell-wrapper/GridCellWrapper';
import { connect } from 'react-redux';
import {
  deleteAuftrag,
  getAuftraege,
  getDefaultstatuskette,
  set_From_and_To_Date,
  setAuftraegeSortBy,
  setAuftragResearchField,
  zurTypUebertragungMarkieren,
  zurUebertragungDeMarkieren,
  zurUebertragungMarkieren,
} from '../../../redux/actions/auftrag';
import { getAnzeigeStati } from '../../../redux/actions/admin';
import Table from '../../../components/table/Table';
import {
  calcCurrentDate,
  isoDateIsValid,
  isoDateToDate,
  isoDateToLocalDateIgnoreTime,
  utcIsoDateToLocaleDate,
} from '../../../utils/date';
import Toolbar from '../../../components/toolbar/Toolbar';
import { initAuftragsresearchTableConfig } from './AuftragsresearchTableConfig';
import Button from '../../../components/button/Button';
import { setActiveTab } from '../../../redux/actions/routing';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import {
  getAuftragById,
  resetAuftragserfassung,
  setAuftragId,
  setAuftragKopieId,
} from '../../../redux/actions/auftragserfassung';
import Sidebar from '../../../components/sidebar/Sidebar';

import InputFieldText from '../../../components/input/floating-label/input-field/InputFieldText';
import AuftragSidebarTab from './tabs/auftrag/AuftragSidebarTab';
import AuftragHistorieSidebarTab from './tabs/historie/AuftragHistorieSidebarTab';
import DropDown from '../../../components/dropdown/Dropdown';
import { ReportModel } from '../../../models/ReportModel';
import { getReports, printReports } from '../../../redux/actions/reports';
import { StateModel } from '../../../redux/store';
import { download, objectArrayToCsv } from '../../../utils/downloadUtils';
import Select from '../../../components/select/Select';
import { getMandantenByHauptmandant } from '../../../redux/actions/mandant';
import {
  Auftrag,
  MandantSummary,
  Sendungsstatus,
  Status,
  UserAnsicht,
  UserAnsichtService,
} from '../../../api';
import { setNotification } from '../../../utils/notificationUtils';
import { AuftragModel } from '../../../models/AuftragModel';
import { toSelectOptions } from '../../../components/select/SelectModel';
import { nameof } from '../../../utils/objectUtils';
import { compareValues } from '../../../utils/comparators';
import AuftragDokumenteSidebarTab from './tabs/dokumente/AuftragDokumenteSidebarTab';
import { INFO } from '../../notification/Notification';
import Modal from '../../../components/modal/Modal';
import { getStati } from '../../../redux/actions/status';
import { initAuftragsresearchTableConfig_MMT } from './AuftragsresearchTableConfig_MMT';
import { ConfigModel } from '../../../models/ConfigModel';
import { setCurrentMandantId } from '../../../redux/actions/user-session';
import { initAuftragsresearchTableConfig_BEXITY } from './AuftragsresearchTableConfig_BEXITY';
import {
  AUFTRAGSTYP_KALKULATION,
  STATUS_ZU_UEBERTRAGEN,
} from '../../../utils/constants';
import Pagination from '../../../components/pagination/Pagination';
import {
  dateCategories,
  DateCategoryProps,
} from '../../../utils/dateCategories';
import { AuftragDefaultServiceModel } from '../../../models/AuftragDefaultServiceModel';
import { Dispatch } from 'redux';
import { ActionTypes, ReduxAction } from '../../../redux/actions/types';
import { toNumber } from 'lodash';
import { initAuftragsresearchTableConfig_GERSTLAUER } from './AuftragsresearchTableConfig_GERSTLAUER';

interface OffeneauftraegeProps {
  auftragsResearch: any;
  getAuftraege: any;
  setActiveTab: (active: string) => void;
  setAuftragId: (auftragNummer: number | undefined) => void;
  setAuftragKopieId: (auftragNummer: number | undefined) => void;
  zurUebertragungMarkieren: (auftragIds: number[], reLoad: () => void) => void;
  zurUebertragungDeMarkieren: (auftragIds: number[]) => void;
  zurTypUebertragungMarkieren: (typ: number, auftragIds: number[]) => void;
  getReports: () => void;
  reports: Array<ReportModel>;
  printReports: (auftragIDs: number[], report: ReportModel) => void;
  isHauptmandant: boolean;
  mandantenByHauptmandant: MandantSummary[];
  getMandantenByHauptmandant: () => void;
  setAuftragResearchField: (value: any, fieldname: string) => void;
  reloadToggle: boolean;
  getDefaultstatuskette: () => void;
  getAnzeigeStati: (value: string) => void;
  setAuftraegeSortBy: (attributeName: string, sortingCount: number) => void;
  resetAuftragserfassung: () => void;
  isMetro: boolean;
  isAuftragEdit: boolean;
  anzeigestati: Sendungsstatus[];
  deleteAuftrag: (auftragId: number[]) => void;
  getAuftragById: (value: number) => void;
  auftragsErfassung: any;
  getStati: () => void;
  stati: Status[];
  set_From_and_To_Date: (dateFrom: string, dateTo: string) => void;
  config: ConfigModel;
  clientKunde: string;
  nichtUebertrageneAuftraege: boolean | undefined;
  currentMandantId: string;
  setCurrentMandantId: (id: number | undefined) => void;
  rowsInGrid: number;
  dynamicServices: AuftragDefaultServiceModel[];
  currentUserId: string;
}

/**
 * Auftragsresearch-Component
 * Dient zur Suche von Aufträgen.
 *
 * @returns {JSX.Element} Auftragsresearch-Component
 * @constructor
 */
const Offeneauftraege = ({
  getAuftraege,
  auftragsResearch,
  setActiveTab,
  history,
  setAuftragId,
  setAuftragKopieId,
  zurUebertragungMarkieren,
  zurUebertragungDeMarkieren,
  zurTypUebertragungMarkieren,
  reports,
  getReports,
  printReports,
  isHauptmandant,
  mandantenByHauptmandant,
  getMandantenByHauptmandant,
  setAuftragResearchField,
  getDefaultstatuskette,
  getAnzeigeStati,
  setAuftraegeSortBy,
  resetAuftragserfassung,
  isMetro,
  isAuftragEdit,
  anzeigestati,
  deleteAuftrag,
  getStati,
  stati,
  set_From_and_To_Date,
  config,
  currentMandantId,
  setCurrentMandantId,
  rowsInGrid,
  dynamicServices,
  currentUserId,
}: OffeneauftraegeProps & RouteComponentProps) => {
  const [activeSidebarTab, setActiveSidebarTab] = useState('auftrag');
  const [mandanten, setMandanten] = useState<MandantSummary[]>([]);
  const [nichtUebertrageneAuftraege, setNichtUebertrageneAuftraege] =
    useState(false);
  const [lastSelectedColumnHeader, setLastSelectedColumnHeader] = useState<
    number | undefined
  >();
  const ubertragungsButtonTooltip = config.clientKunde
    ? 'an ' +
      (config.clientKunde.toUpperCase() === 'BEXITY'
        ? 'Raben BEXity'
        : config.clientKunde) +
      ' übertragen'
    : 'an DPlus übertragen';

  /**
   * Konvertiert Auftraege in das AuftragresearchTableModel zur visualisierung in der Tabelle
   */
  const convertCurrentAuftraegeIntoResearchList = (): Array<any> => {
    const newAuftragsliste = [...auftragsResearch.auftragsliste];
    const maxShownLines = rowsInGrid;
    return newAuftragsliste.map((auftragAsJson: Auftrag, index: number) => {
      index++;

      if (index <= maxShownLines && auftragAsJson.status?.id != undefined) {
        if (auftragAsJson.status?.id === 1) setNichtUebertrageneAuftraege(true);
      }

      return {
        id: auftragAsJson.id,
        elementId: index,
        datum: isoDateToLocalDateIgnoreTime(auftragAsJson.datum ?? ''),
        beladedatum: isoDateToLocalDateIgnoreTime(
          auftragAsJson.abholDatumVon ?? ''
        ),
        zustellDatum: isoDateToLocalDateIgnoreTime(
          auftragAsJson.zustellDatumVon ?? ''
        ),
        mitGefahrguetern: auftragAsJson.mitGefahrguetern,
        spedeigennr: auftragAsJson.spedeigennr ?? '',
        spedfremdnr: auftragAsJson.spedfremdnr ?? '',
        zeichennr: auftragAsJson.auftragspositionen?.[0]?.zeichenNummer ?? '',
        lieferschein: auftragAsJson.auftragspositionen?.[0]?.lieferschein ?? '',
        zustellart: auftragAsJson.zustellkennzeichen?.kurzBezeichnung ?? '',
        absenderReferenz: auftragAsJson.spedfremdnr ?? '',
        empfaengerReferenz: auftragAsJson.empfaengerReferenz ?? '',
        partnerreferenz: auftragAsJson.partnerReferenz ?? '',
        sumBruttoGewicht: auftragAsJson.sumBruttoGewicht ?? '',
        absender_matchcode: auftragAsJson.absenderAdresse?.matchcode ?? '',
        absender_name: auftragAsJson.absenderAdresse?.name ?? '',
        absender_plz: auftragAsJson.absenderAdresse?.plz ?? '',
        absender_ort: auftragAsJson.absenderAdresse?.ort ?? '',
        absender_strasse: auftragAsJson.absenderAdresse?.strasse ?? '',
        empfaenger_matchcode: auftragAsJson.empfaengerAdresse?.matchcode ?? '',
        empfaenger_name: auftragAsJson.empfaengerAdresse?.name ?? '',
        empfaenger_plz: auftragAsJson.empfaengerAdresse?.plz ?? '',
        empfaenger_ort: auftragAsJson.empfaengerAdresse?.ort ?? '',
        empfaenger_strasse: auftragAsJson.empfaengerAdresse?.strasse ?? '',
        status: auftragAsJson.sdstId
          ? getSendungsstatus(auftragAsJson)
          : getStatus(auftragAsJson),
        abliefernachweisExists: auftragAsJson.abliefernachweisExists,
        hinweis: auftragAsJson.hinweis ?? '',
        sperrigkeit: auftragAsJson.sperrigkeit?.bezkurz ?? '',
        rechnungsadresse_matchcode:
          auftragAsJson.rechnungsempfaengerAdresse?.matchcode ?? '',
        rechnungsadresse_name:
          auftragAsJson.rechnungsempfaengerAdresse?.name ?? '',
        rechnungsadresse_strasse:
          auftragAsJson.rechnungsempfaengerAdresse?.strasse ?? '',
        rechnungsadresse_plz:
          auftragAsJson.rechnungsempfaengerAdresse?.plz ?? '',
        rechnungsadresse_ort:
          auftragAsJson.rechnungsempfaengerAdresse?.ort ?? '',
        nachnahmeadresse_name:
          auftragAsJson.nachnahmeempfaengerAdresse?.name ?? '',
        nachnahmeadresse_strasse:
          auftragAsJson.nachnahmeempfaengerAdresse?.strasse ?? '',
        nachnahmeadresse_plz:
          auftragAsJson.nachnahmeempfaengerAdresse?.plz ?? '',
        nachnahmeadresse_ort:
          auftragAsJson.nachnahmeempfaengerAdresse?.ort ?? '',
        mandant: auftragAsJson.mandant?.name ?? '',
        sumPackstueckAnzahl: isMetro
          ? auftragAsJson.sumPackstueckAnzahl
          : auftragAsJson.sumVerpackungAnzahl,
        berechnBetrag: auftragAsJson.berechnBetrag,
        berechnWaehrung: auftragAsJson.berechnWaehrung?.bezeichnungKurz,
      };
    });
  };
  const chooseTableConfig = () => {
    return config.auftragsresearchtableconfig === 'MMT'
      ? initAuftragsresearchTableConfig_MMT()
      : config.auftragsresearchtableconfig === 'BEXITY'
      ? initAuftragsresearchTableConfig_BEXITY()
      : config.auftragsresearchtableconfig === 'GERSTLAUER'
      ? initAuftragsresearchTableConfig_GERSTLAUER()
      : initAuftragsresearchTableConfig();
  };

  const [tableConfig, setTableConfig] = useState(chooseTableConfig);
  const [data, setData] = useState<Array<any>>([{}]);
  const [selectedRow, setSelectedRow] = useState<any>(undefined);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [query, setQuery] = useState<string>('');
  const [dateCategoriesId, setDateCategoriesId] = useState(0);
  const [userTableConfigSet, setuserTableConfigSet] = useState<boolean>(false);

  const [dateFrom, setDateFrom] = useState<string>(
    !auftragsResearch.dateFrom
      ? process.env.NODE_ENV === 'production'
        ? calcCurrentDate(-10, false)
        : calcCurrentDate(-100, false)
      : auftragsResearch.dateFrom
  );
  const [dateTo, setDateTo] = useState<string>(
    !auftragsResearch.dateTo
      ? calcCurrentDate(+5, true)
      : auftragsResearch.dateTo
  );

  useEffect(() => {
    if (data[selectedRow] === undefined) {
      setSelectedRow(undefined);
    }
  }, [data]);

  const getSendungsstatus = (auftrag: Auftrag) => {
    const sdgstatus = auftrag.auftragshistorie?.find(
      hist => hist.sendungsstatus?.id === auftrag.sdstId
    );
    const anzeigestatus = anzeigestati.find(
      status => status.id == sdgstatus?.sendungsstatus?.sdst_id_anzeige
    );
    return (
      anzeigestatus?.kurzBezeichnung ??
      sdgstatus?.sendungsstatus?.kurzBezeichnung
    );
  };

  const getStatus = (auftrag: Auftrag) => {
    if (
      auftrag.status?.id === STATUS_ZU_UEBERTRAGEN &&
      auftrag.typ === AUFTRAGSTYP_KALKULATION
    ) {
      return 'Preisermittlung in Arbeit...';
    }
    if (
      auftrag.kalkulationsFolgeId != undefined &&
      auftrag.typ === AUFTRAGSTYP_KALKULATION
    ) {
      return 'Preisermittlung ist erfolgt';
    }
    return auftrag.status?.kurzBezeichnung ?? '';
  };

  const [showLoeschen, setShowLoeschen] = useState(false);
  const [page, setPage] = useState(1);
  const [userAnsicht, setUserAnsicht] = useState<null | UserAnsicht>(null);

  useEffect(() => {
    getReports();
    getMandantenByHauptmandant();
    getDefaultstatuskette();
    getAnzeigeStati('');
    getStati();
  }, []);

  useEffect(() => {
    if (!userTableConfigSet) getUserAnsicht(1);
  }, [tableConfig]);
  useEffect(() => {
    if (userAnsicht?.configjson && !userTableConfigSet) {
      setTableConfig(JSON.parse(userAnsicht.configjson));
      setuserTableConfigSet(true);
    }
  }, [userAnsicht]);

  useEffect(() => {
    setMandanten(mandantenByHauptmandant);
  }, [mandantenByHauptmandant]);

  useEffect(() => {
    set_From_and_To_Date(dateFrom, dateTo);
  }, [dateFrom, dateTo]);

  useEffect(() => {
    const searchMandantID =
      +currentMandantId ?? auftragsResearch.mandant?.id ?? undefined;

    if (searchMandantID) {
      if (
        (query !== '' || dateFrom !== '' || dateTo !== '' || searchMandantID) &&
        checkValidDates()
      ) {
        set_From_and_To_Date(dateFrom, dateTo);
        setPage(1);
        fetchData(searchMandantID, 1);
      }
    }
  }, [query, dateFrom, dateTo, dateCategoriesId, currentMandantId]);
  useEffect(() => {
    setLastSelectedColumnHeader(undefined);
  }, [selectedRow, selectedRows]);

  /**
   * UseEffect wird ausgeführt, wenn sich die
   * Dependency / das Attribut verändert (in eckigen Klammern)
   */
  useEffect(() => {
    setNichtUebertrageneAuftraege(false);
  }, [query, auftragsResearch.mandant?.id, auftragsResearch.reloadToggle]);

  useEffect(() => {
    setNichtUebertrageneAuftraege(false);
    if (getSorting() !== 'default') {
      const sortedData = [...convertCurrentAuftraegeIntoResearchList()];
      setData(
        sortedData.sort(compareValues(auftragsResearch.sortBy, getSorting()))
      );
    } else {
      setData(
        auftragsResearch.auftragsliste
          ? convertCurrentAuftraegeIntoResearchList()
          : [{}]
      );
    }
  }, [
    auftragsResearch.auftragsliste,
    auftragsResearch.sortBy,
    auftragsResearch.sortingCount,
  ]);
  const handleSetLastSelectedColumnHeader = (
    header: React.SetStateAction<number | undefined>
  ) => {
    setLastSelectedColumnHeader(header);
  };
  const getUserAnsicht = (tabellenTyp: number) => {
    new UserAnsichtService().getUserAnsicht(tabellenTyp).then(response => {
      setUserAnsicht(response.data);
    });
  };
  const checkValidDates = () => {
    return (
      isoDateIsValid(dateFrom) && isoDateIsValid(dateTo) && dateFrom <= dateTo
    );
  };

  const fetchData = (mandantId: number, page: number) => {
    getAuftraege(
      query,
      page,
      rowsInGrid,
      isoDateToDate(dateFrom),
      isoDateToDate(dateTo),
      dateCategories[Number(dateCategoriesId)].value,
      mandantId,
      true
    );
  };

  const fetchMoreData = (page: number) => {
    setPage(page);
    fetchData(auftragsResearch.mandant?.id, page);
  };

  const getSorting = () => {
    switch (auftragsResearch.sortingCount) {
      case 0:
        return 'default';
      case 1:
        return 'asc';
      case 2:
        return 'desc';
      default:
        return 'default';
    }
  };

  const editAuftrag = () => {
    if (selectedRow || selectedRow == 0) {
      const auftragsId: number = data[selectedRow].id;
      if (auftragsId) {
        setAuftragId(auftragsId);
        setAuftragKopieId(undefined);
        setActiveTab('auftragsmanagement');
        history.push(`/auftragsmanagement/auftragserfassung/${auftragsId}`);
      }
    } else {
      setNotification('Bitte markieren Sie eine Zeile.', []);
    }
  };

  const copyAuftrag = () => {
    if (selectedRow || selectedRow == 0) {
      const auftragsId: number = data[selectedRow].id;
      if (auftragsId) {
        setAuftragKopieId(auftragsId);
        setActiveTab('auftragsmanagement');
        history.push(`/auftragsmanagement/auftragserfassung`);
      }
    } else {
      setNotification('Bitte markieren Sie eine Zeile.', []);
    }
  };

  const sendeAuftraegeAnDplus = () => {
    if (selectedRows.length > 0) {
      const auftragIds: number[] = [];
      selectedRows.forEach(row => {
        if (data[row] && data[row].id) auftragIds.push(data[row].id);
      });
      if (auftragIds.length > 0) {
        zurUebertragungMarkieren(auftragIds, reLoad);
        setNotification(
          `${auftragIds.length} ${
            auftragIds.length > 1 ? 'Aufträge wurden' : 'Auftrag wurde'
          } zur Übertragung an DISPONENTplus markiert.`,
          []
        );
      }
    } else if (selectedRow || selectedRow == 0) {
      const auftragsId: number = data[selectedRow].id;
      if (auftragsId) {
        const list: number[] = [auftragsId];
        zurUebertragungMarkieren(list, reLoad);
        setNotification(
          '1 Auftrag wurde zur Übertragung an DISPONENTplus markiert.',
          []
        );
      }
    } else {
      setNotification('Bitte markieren Sie eine Zeile.', []);
    }
  };

  const cancleSendeAuftraegeAnDplus = () => {
    if (selectedRows.length > 0) {
      const auftragIds: number[] = [];
      selectedRows.forEach(row => {
        if (data[row] && data[row].id) auftragIds.push(data[row].id);
      });
      if (auftragIds.length > 0) {
        zurUebertragungDeMarkieren(auftragIds);
      }
    } else if (selectedRow || selectedRow == 0) {
      const auftragsId: number = data[selectedRow].id;
      if (auftragsId) {
        const list: number[] = [auftragsId];
        zurUebertragungDeMarkieren(list);
      }
    } else {
      setNotification('Bitte markieren Sie eine Zeile.', []);
    }
  };

  const sendePreisermittlung = () => {
    if (selectedRows.length > 0) {
      const auftragIds: number[] = [];
      selectedRows.forEach(row => {
        if (data[row] && data[row].id) auftragIds.push(data[row].id);
      });
      if (auftragIds.length > 0) {
        zurTypUebertragungMarkieren(AUFTRAGSTYP_KALKULATION, auftragIds);
      }
    } else if (selectedRow || selectedRow == 0) {
      const auftragsId: number = data[selectedRow].id;
      if (auftragsId) {
        const list: number[] = [auftragsId];

        zurTypUebertragungMarkieren(AUFTRAGSTYP_KALKULATION, list);
      }
    } else {
      setNotification('Bitte markieren Sie eine Zeile.', []);
    }
  };

  const printReport = (report: ReportModel) => {
    if (selectedRows.length > 0) {
      const auftragIds: number[] = [];
      selectedRows.forEach(row => {
        if (data[row].id) auftragIds.push(data[row].id);
      });

      if (auftragIds.length > 0) {
        printReports(auftragIds, report);
      }
    } else {
      setNotification('Bitte markieren Sie eine Zeile.', []);
    }

    return null;
  };

  const exportToExcel = (data: Array<any>) => {
    if (selectedRows.length > 0) {
      const auftraege: AuftragModel[] = [];
      selectedRows.forEach(row => {
        auftraege.push(data[row]);
      });
      const auftrag = objectArrayToCsv(auftraege);
      download(auftrag, 'Auftrag.csv');
    } else {
      setNotification('Bitte markieren Sie eine Zeile.', []);
    }
  };
  const reLoad = () => {
    setNichtUebertrageneAuftraege(false);
    fetchData(auftragsResearch.mandant?.id ?? currentMandantId, page);
  };

  const delAuftrag = () => {
    setShowLoeschen(false);
    if (selectedRows.length > 0) {
      const auftragIds: number[] = [];
      selectedRows.forEach(row => {
        if (data[row].id) auftragIds.push(data[row].id);
      });
      if (auftragIds.length > 0) {
        deleteAuftrag(auftragIds);
      }
    } else if (selectedRow || selectedRow == 0) {
      const auftragsId: number = data[selectedRow].id;
      if (auftragsId) {
        const list: number[] = [auftragsId];
        deleteAuftrag(list);
      }
    } else {
      setNotification('Bitte markieren Sie eine Zeile.', []);
    }
  };
  /**
   * Steuert die Öffnung vom Modalen Fenster
   */
  const handleOpen = () => {
    if (selectedRow || selectedRow == 0) {
      setShowLoeschen(true);
    } else {
      setNotification('Bitte markieren Sie eine Zeile.', [], INFO, 5000);
    }
  };

  const handleClose = () => {
    setShowLoeschen(false);
  };

  function disableDeleteButton() {
    if (selectedRows.length != 1) {
      return true;
    }

    try {
      const readedStatus = stati?.find(
        status => status.kurzBezeichnung == data[selectedRow].status
      );
      return readedStatus?.id != 1 && readedStatus?.id != 2;
    } catch (e) {
      return true;
    }
  }
  function disablePreisButton(data: Array<any>) {
    if (selectedRows.length != 1) {
      return true;
    }

    try {
      const readedStatus = stati?.find(
        status => status.kurzBezeichnung == data[selectedRow].status
      );
      return readedStatus?.id != 1;
    } catch (e) {
      return true;
    }
  }

  const getSelectedAuftrag = () => {
    let selectedAuftrag = undefined;
    if (data[selectedRow]) {
      selectedAuftrag = auftragsResearch.auftragsliste.find((auf: Auftrag) => {
        return auf.id === data[selectedRow].id;
      });
    }
    return selectedAuftrag;
  };
  const saveUserAnsicht = () => async (dispatch: Dispatch<ReduxAction>) => {
    new UserAnsichtService()
      .saveUserAnsicht(1, JSON.stringify(tableConfig))
      .then(response => {
        dispatch({
          type: ActionTypes.SET_USER_ANSICHT,
          payload: response.data,
        });
      });
  };

  return (
    <Fragment>
      <div className='auftragsresearch-wrapper'>
        <Toolbar>
          {isAuftragEdit && (
            <Link to='/auftragsmanagement/auftragserfassung'>
              <Button
                tooltip='neuer Auftrag'
                classes={'iconButton'}
                key={0}
                onClickHandler={() => {
                  resetAuftragserfassung();
                  setActiveTab('auftragsmanagement');
                }}
              >
                <i className='far fa-plus-square fa-2x' />
              </Button>
            </Link>
          )}
          <Button
            tooltip={
              isAuftragEdit ? 'Auftrag bearbeiten' : 'Auftrag Details ansehen'
            }
            classes={'iconButton'}
            key={1}
            onClickHandler={() => {
              resetAuftragserfassung();
              editAuftrag();
            }}
          >
            <i className='far fa-edit fa-2x' />
          </Button>
          {isAuftragEdit && (
            <Link to='/auftragsmanagement/auftragserfassung'>
              <Button
                tooltip='Auftrag kopieren'
                classes={'iconButton'}
                key={2}
                onClickHandler={() => {
                  resetAuftragserfassung();
                  copyAuftrag();
                }}
              >
                <i className='far fa-copy fa-2x' />
              </Button>
            </Link>
          )}
          {isAuftragEdit && (
            <Button
              tooltip={ubertragungsButtonTooltip}
              classes={
                nichtUebertrageneAuftraege === true
                  ? 'buttonbordered'
                  : 'iconButton'
              }
              key={3}
              onClickHandler={() => {
                sendeAuftraegeAnDplus();
              }}
              disabled={!nichtUebertrageneAuftraege}
            >
              <i className='far fa-share-square fa-2x' />
            </Button>
          )}
          {isAuftragEdit && (
            <Button
              tooltip='Übertragung abbrechen'
              classes={'iconButton'}
              key={4}
              onClickHandler={() => {
                cancleSendeAuftraegeAnDplus();
              }}
            >
              <i className='fas fa-ban fa-2x' />
            </Button>
          )}
          <Button
            tooltip='Auftrag löschen'
            classes={'iconButton'}
            key={5}
            disabled={disableDeleteButton()}
            onClickHandler={() => {
              handleOpen();
            }}
          >
            <i className='far fa-trash-alt fa-2x color-red' />
          </Button>
          <Button
            tooltip='Auftrag als CSV exportieren'
            classes={'iconButton'}
            key={6}
            onClickHandler={() => {
              exportToExcel(data);
            }}
          >
            <i className='far fa-file-excel fa-2x' />
          </Button>
          {config.isPreisermittlung && (
            <Button
              tooltip='Preisermittlung'
              classes={'iconButton'}
              key={8}
              disabled={disablePreisButton(data)}
              onClickHandler={() => {
                sendePreisermittlung();
              }}
            >
              <i className='fas fa-euro-sign fa-2x' />
            </Button>
          )}
          <DropDown icon='fas fa-print fa-lg' title='Drucken'>
            {reports
              .filter(
                report =>
                  report.reportFileName !== 'BexUebernahmeListeOracle.jasper'
              )
              .map((report, index) => {
                return (
                  <span
                    key={index}
                    id={'' + report.id}
                    onClick={() => printReport(report)}
                  >
                    {report.label}
                  </span>
                );
              })}
          </DropDown>
          {isHauptmandant && (
            <Select
              className='adr-mandant'
              headerTitle='Mandant'
              onChangeHandler={(id?: number) => {
                const mandant = mandanten.find(mandant => mandant.id === id);
                setAuftragResearchField(mandant, 'mandant');
                if (mandant?.id) {
                  setCurrentMandantId(mandant?.id);
                }
              }}
              selectedOptionId={Number(currentMandantId)}
              selectData={toSelectOptions(mandanten, 'name', false)}
            />
          )}
          <div className={'search-field-wrapper'}>
            <i className='fas fa-search fa-lg' />
            <InputFieldText
              label={
                config.auftragsresearchtableconfig === 'MMT'
                  ? 'Sendung, Kunden-AB, Kommision, Lieferschein etc.'
                  : 'Auftragsnummer, Empfänger, ...Referenz etc.'
              }
              name='search'
              classes='search-field'
              onChangeHandler={setQuery}
              maxlength={200}
              value={query}
            />
            <Button
              tooltip='aktualisieren'
              classes={'iconButton'}
              key={7}
              onClickHandler={() => {
                reLoad();
              }}
            >
              <i className='fas fa-redo' />
            </Button>
          </div>
          <InputFieldText
            label='Datum von'
            classes='date'
            inputType='date'
            onChangeHandler={setDateFrom}
            value={dateFrom}
          />
          <InputFieldText
            label='Datum bis'
            classes='date'
            inputType='date'
            onChangeHandler={setDateTo}
            value={dateTo}
          />
          <Select
            className='select-date-categories'
            headerTitle='Datumskategorie'
            onChangeHandler={value => setDateCategoriesId(value ?? 0)}
            selectedOptionId={dateCategoriesId}
            selectData={toSelectOptions(
              dateCategories,
              nameof<DateCategoryProps>('bezeichnung'),
              false
            )}
          />
          <Button
            tooltip='aktualisieren'
            classes={'aktButton'}
            key={77}
            onClickHandler={() => {
              reLoad();
            }}
          >
            aktualisieren
          </Button>
        </Toolbar>
        <div className={'auftragsresearch_sidebar'}>
          <GridCellWrapper
            classes='auftragsresearch'
            label='offene Aufträge'
            saveUserAnsicht={saveUserAnsicht}
            withColumnSortable
            lastSelectedColumnHeader={lastSelectedColumnHeader}
            tableConfig={tableConfig}
            setTableConfig={setTableConfig}
            setLastSelectedColumnHeader={handleSetLastSelectedColumnHeader}
            layoutName={'Auftragsresearch'}
            defaultKundeTableConfig={chooseTableConfig()}
          >
            {
              <Table
                tableConfig={tableConfig}
                setTableConfig={setTableConfig}
                data={data}
                tabSkipIndices={[0]}
                edit={false}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                doubleClickRowHandler={editAuftrag}
                setAuftraegeSortBy={setAuftraegeSortBy}
                sortingCount={auftragsResearch.sortingCount}
                sortBy={auftragsResearch.sortBy}
                toggleSort={auftragsResearch.toggleSort}
                searchQueryString={query}
                lastSelectedColumnHeader={lastSelectedColumnHeader}
                setLastSelectedColumnHeader={handleSetLastSelectedColumnHeader}
              />
            }
            <Pagination
              onClickHandler={fetchMoreData}
              totalCount={+auftragsResearch.totalSearchResults}
              countPerPage={rowsInGrid}
              currentPage={page}
            />
          </GridCellWrapper>
          <Sidebar open={false}>
            <div className='work-tabs'>
              <button
                onClick={() => setActiveSidebarTab('auftrag')}
                className={`${activeSidebarTab === 'auftrag' ? 'active' : ''}`}
              >
                Auftrag
              </button>
              <button
                onClick={() => setActiveSidebarTab('historie')}
                className={`${activeSidebarTab === 'historie' ? 'active' : ''}`}
              >
                Historie
              </button>
              <button
                onClick={() => setActiveSidebarTab('dokumente')}
                className={`${
                  activeSidebarTab === 'dokumente' ? 'active' : ''
                }`}
              >
                Dokumente
              </button>
            </div>
            {/*AuftragTab*/}
            {activeSidebarTab === 'auftrag' &&
              (selectedRow != undefined ? (
                <AuftragSidebarTab
                  selectedAuftrag={getSelectedAuftrag()}
                  dynamicServices={dynamicServices}
                />
              ) : (
                <p className={'tab-info'}>
                  {'Bitte markieren Sie einen Auftrag.'}
                </p>
              ))}
            {activeSidebarTab === 'historie' &&
              (selectedRow != undefined ? (
                <AuftragHistorieSidebarTab
                  selectedAuftrag={getSelectedAuftrag()}
                />
              ) : (
                <p className={'tab-info'}>
                  {'Bitte markieren Sie einen Auftrag.'}
                </p>
              ))}
            {activeSidebarTab === 'dokumente' &&
              (selectedRow != undefined ? (
                <AuftragDokumenteSidebarTab
                  selectedAuftrag={getSelectedAuftrag()}
                />
              ) : (
                <p className={'tab-info'}>
                  {'Bitte markieren Sie einen Auftrag.'}
                </p>
              ))}
            {activeSidebarTab === 'verladung' && <span>Verladung</span>}
            {activeSidebarTab === 'controlling' && <span>Controlling</span>}
          </Sidebar>
        </div>
      </div>
      <Modal
        show={showLoeschen}
        closeHandler={handleClose}
        titel='Auftrag löschen'
        description={'Soll der markierte Auftrag entfernt werden?'}
      >
        <div className='modal-btn-group'>
          <button className='modal-btn' onClick={() => delAuftrag()}>
            Ja
          </button>
          <button className='modal-btn' onClick={handleClose}>
            Nein
          </button>
        </div>
      </Modal>
    </Fragment>
  );
};

const mapStateToProps = (state: StateModel) => ({
  auftragsResearch: state.Auftraege,
  reports: state.Stammdaten.reports,
  isHauptmandant: state.UserSession.isHauptmandant,
  mandantenByHauptmandant: state.Stammdaten.mandanten,
  isMetro: state.UserSession.isMetro,
  isAuftragEdit: state.UserSession.isAuftragEdit,
  anzeigestati: state.Admin.anzeigeStati,
  auftragsErfassung: state.Auftragserfassung,
  stati: state.Stammdaten.stati,
  config: state.Config,
  currentMandantId: state.UserSession.currentMandantId,
  rowsInGrid: state.UserSession.rowsInGrid,
  dynamicServices: state.Stammdaten.dynamicServices,
  currentUserId: state.Auth.userID ?? '',
});

export default connect(mapStateToProps, {
  getAuftraege,
  setActiveTab,
  setAuftragId,
  setAuftragKopieId,
  zurUebertragungMarkieren,
  zurUebertragungDeMarkieren,
  zurTypUebertragungMarkieren,
  getReports,
  printReports,
  setAuftragResearchField,
  getMandantenByHauptmandant,
  getDefaultstatuskette,
  getAnzeigeStati,
  setAuftraegeSortBy,
  resetAuftragserfassung,
  deleteAuftrag,
  getAuftragById,
  getStati,
  set_From_and_To_Date,
  setCurrentMandantId,
})(withRouter(Offeneauftraege));
